import React from 'react';
import Slider from 'react-slick';
import image01 from '../image/image01.jpg';
import image02 from '../image/image02.jpg';
import image03 from '../image/image03.jpg';
import image04 from '../image/image04.jpg';


const ImageSlider: React.FC = () => {
  const images: string[] = [image01, image02, image03, image04];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <div className="mt-6">
      <Slider {...settings}>
        {images.map((img, index) => (
          <div key={index} className="h-72 sm:h-96">
            <img src={img} title={`photo by Tanesaka Eiji`} alt={`スライド${index + 1}`} className="w-full h-full object-cover rounded-lg" />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;
